
import * as ipxRuntime$Ou4YTokZDkU_45WeEVb1L7Vw46pHbGRl4T_gJNFIgHZYo from '/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$Ou4YTokZDkU_45WeEVb1L7Vw46pHbGRl4T_gJNFIgHZYo, defaults: {} }
}
        